const ImageElementModel = {
  description: { pl: '' },
  imageUrl: '',
  thumbUrl: '',
};

export default ImageElementModel;
